/*
 * @Author: 赵大壮 372839241@qq.com
 * @Date: 2026-02-25 22:26:41
 * @LastEditors: 赵大壮 372839241@qq.com
 * @LastEditTime: 2026-02-25 22:26:59
 * @FilePath: \利享乡村管理后台\src\views\用户管理\model\DZModelZQUser.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
class DZModelZQUser {
    id = "";
    phone = ""
    password = ""
    password2 = ""
    name = ""
    governmentName = ""

    init() {
        this.phone = "";
        this.password = "";
        this.name = "";
        this.governmentName = "";
    }
}
export default DZModelZQUser;